import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProductSubCategoryListViewModal from '../../../../views/app/common/modal/ProductSubCategoryListViewModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class ProductSubCategoryListViewModalContainer extends Component {
  /**
   *  모달 닫기
   */
  closeModal = () => {
    const { appToggleModal } = this.props;
    appToggleModal({ name: 'productSubCategoryListViewModal' });
  };

  render() {
    const { isOpen, data } = this.props;

    return <ProductSubCategoryListViewModal isOpen={isOpen} data={data} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.productSubCategoryListViewModal.isOpen,
    data: state.app.productSubCategoryListViewModal.data,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ProductSubCategoryListViewModalContainer));
